fx.ns("shared.popups", class NoticeSelectFiles extends fx.components.Popup{
    
    constructor()
    {
        super();

        this.contentWidth = 450;
        this.contentHeight = 330;
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.close, this.okButton);
        this.on("ENTER", this.close, fx.keyboard);
        this.on("ESCAPE", this.close, fx.keyboard);
    }

    create()
    {
        super.create();
 
        this.addChild(new shared.component.Person(fx.get("assets").personAdvice), {width:200, height : 200, top : -100, left : "center"});

        this.addChild(new fx.components.Text({text:fx.text("Une petite astuce ?"), className:"title center"}), {height:30, left:0, top:120, width:"100%"});
        this.addChild(new fx.components.Text({text:fx.text("Pour sélectionner toutes les photos d'un répertoire, pressez en même temps les touches <strong>$ et A</strong>.", (fx.browser.isMac ? "COMMAND" : "CTRL")), className:"text center"}), {left:0, top:175, width:"100%"});
        

        // botton    
        this.okButton = new fx.components.Button({label : fx.text("Ok, c'est parti !"), type : "filled"});
        this.addChild(this.okButton, {bottom:20, height:60, width : 200, left:"center"});

    }


});